import { UiModal, UiToast } from 'components';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { base, browser, hoc, user, qtClient } from 'lib';
import { getGlobalStore, globalStore, useGlobalStore } from 'stores';
// import { qtClient } from "client/pc/lib";

import { useRouter } from 'next/router';
import { useBoolean } from 'react-hanger';
import { Provider, store, useStore } from './store';
import PasswordLogin from './password-login';
import MobileLogin from './mobile-login';
import MobileRegister from './mobile-register';

const LoginModal = styled(UiModal)`
  width: 784px;
  height: 466px;

  .inner-header {
    -webkit-app-region: drag;
    position: absolute;
    top: 0;
    left: 0;
    right: 64px;
    height: 32px;
  }

  .inner {
    width: 784px;
    padding: 32px 0 0 305px !important; // 305 + 84
    height: 466px;
    background: url(${require('./images/bg.png')}) 0 0 / contain no-repeat !important;
  }

  .login-logo {
    background: url(${require('./images/logo.png')}) 0 0 / contain no-repeat;
    width: 92px;
    height: 22px;
    position: absolute;
    left: 100px;
    bottom: 40px;
  }

  .modal-title {
    font-size: var(--fs-lg);
    width: 100%;
    text-align: center;
  }

  .modal-close {
    right: 32px;

    .iconfont {
      font-size: var(--fs-base);
    }
  }
`;

const useStorageEvent = (handler) => {
  useEffect(() => {
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener('storage', handler);
    };
  }, []);
};

const loginCheck = () => {
  // const { userInfo } = getGlobalStore();
  // if (!userInfo.isAnchor) {
  //   user.clearUserInfo();
  //   UiToast.warn('登录失败，请先申请开播获得主播权限');
  //   return false;
  // }
};

const Modal = observer((props) => {
  const { isRegister } = props;
  const { loginType, setLoginType } = useStore();

  const { setDark, setPageClass, isLogin, userInfo } = useGlobalStore();
  const { query } = useRouter();
  const isThirdLogin = useBoolean(false);

  // 开播工具客户端登录
  qtClient.useEventListen('token', (msg) => {
    user.refreshToken.loadSecurity(msg.data.security, (access_token) => {
      user.onLoginSuccess(
        access_token ? { access_token } : msg,
        '',
        loginCheck,
        msg.data.login_type,
      );
    });
  });

  useEffect(() => {
    if (isRegister) {
      setLoginType('register');
    } else {
      setLoginType('password');
    }
  }, [isRegister]);

  // 开播工具客户端登录的
  // useStorageEvent((e) => {
  //   const { key, newValue, oldValue, url } = e;
  //   if (key === 'CLIENT_LOGIN_TIME') {
  //     // if (window['inPcClient']) {
  //     // user.loadUserInfo((uInfo) => {
  //     //   isThirdLogin.setTrue();
  //     //   globalStore.setLoginSuccess()
  //     // });
  //     // }
  //     user.onLoginSuccess({}, '', loginCheck);
  //   }
  // });

  // 浏览器第三方登录的
  useEffect(() => {
    if (isLogin && query.redirect_from === 'thirdLogin') {
      user.onLoginSuccess({}, '', loginCheck);
    }
  }, [isLogin, query]);

  return (
    <LoginModal
      className="_dark"
      {...props}
      isShowFooter={false}
      title={loginType === 'register' ? '注册' : '登录'}
    >
      <div className="login-logo"></div>
      <div className="inner-header"></div>
      <MobileLogin show={loginType === 'mobile'}></MobileLogin>
      <PasswordLogin show={loginType === 'password'}></PasswordLogin>
      <MobileRegister show={loginType === 'register'}></MobileRegister>
    </LoginModal>
  );
});

const PopupLoginControl = (props) => {
  return (
    <Provider value={store}>
      <Modal {...props}></Modal>
    </Provider>
  );
};

PopupLoginControl.show = (opt) => {
  hoc.render(opt, PopupLoginControl);
};

export default PopupLoginControl;
